<div class="pillar-detail-container">

    @if (viewModel$ | async; as vm) {
        @for (item of vm.content;track item) {

            <div class="pillar-detail-col1">
                <div class="pillar-detail-menu-title">
                    <h2>{{ vm.activeRootTitle }}</h2>
                </div>
                <nav class="pillar-detail-menu">
                    <ul class="pillar-nav-level-1">
                        @for (navItem of vm.navItems; track navItem.title) {
                            @if (navItem.title !== 'Resources') {
                            <li class="pillar-nav-item-level-1">
                                <a [href]="navItem.relative"
                                   [attr.target]="navItem.options?.attributes?.target"
                                   [attr.rel]="navItem.options?.attributes?.target === '_blank' ? 'noopener noreferrer' : null"
                                   class="pillar-nav-link" [class.active]="isActive(navItem.relative)">
                                    {{ navItem.title }}
                                    @if (navItem.below && navItem.below.length > 0) {
                                        <i class="icon-angle-right"></i>
                                    }
                                </a>

                                @if (navItem.below && navItem.below.length > 0) {
                                    <ul class="pillar-nav-level-2">
                                        @for (child of navItem.below; track child.title) {
                                            @if (!isDuplicateLink(child.relative, navItem.relative)) {
                                                <li class="pillar-nav-item-level-2">
                                                    <a [href]="child.relative"
                                                       [attr.target]="child.options?.attributes?.target"
                                                       [attr.rel]="child.options?.attributes?.target === '_blank' ? 'noopener noreferrer' : null"
                                                       class="pillar-nav-link" [class.active]="isActive(child.relative)">
                                                        {{ child.title }}
                                                        @if (child.below && child.below.length > 0) {
                                                            <i class="icon-angle-right"></i>
                                                        }
                                                    </a>

                                                    @if (child.below && child.below.length > 0) {
                                                        <ul class="pillar-nav-level-3">
                                                            @for (grandchild of child.below; track grandchild.title) {
                                                                @if (!isDuplicateLink(grandchild.relative, child.relative)) {
                                                                    <li class="pillar-nav-item-level-3">
                                                                        <a [href]="grandchild.relative"
                                                                           [attr.target]="grandchild.options?.attributes?.target"
                                                                           [attr.rel]="grandchild.options?.attributes?.target === '_blank' ? 'noopener noreferrer' : null"
                                                                           class="pillar-nav-link" [class.active]="isActive(grandchild.relative)">
                                                                            {{ grandchild.title }}
                                                                        </a>
                                                                    </li>
                                                                }
                                                            }
                                                        </ul>
                                                    }
                                                </li>
                                            }
                                        }
                                    </ul>
                                }
                            </li>
                            }
                        }
                    </ul>
                </nav>
            </div>
            
            <div class="pillar-detail-col2">

                <h1 [innerText]="item.title | decodeHtml"></h1>
                <div [innerHTML]="item.body"></div>

                @if (item.parsedResources.items.length > 0) {
                    @if (item.parsedResources.accordionTitleHtml) {
                        <div [innerHTML]="item.parsedResources.accordionTitleHtml"></div>
                    }
                    <div class="pillar-detail-accordion">
                        @for (accordionItem of item.parsedResources.items; track accordionItem.title; let i = $index) {
                            <h3 (click)="toggleAccordion(i)">
                                <i class="icon-angle-right" [class.open]="openStates[i]"></i>
                                {{ accordionItem.title }}
                            </h3>
                            @if (openStates[i]) {
                                <div [innerHTML]="accordionItem.content"></div>
                            }
                        }
                    </div>
                }

                @if (item.parsedResources2.items.length > 0) {
                    @if (item.parsedResources2.accordionTitleHtml) {
                        <div [innerHTML]="item.parsedResources2.accordionTitleHtml"></div>
                    }
                    <div class="pillar-detail-accordion">
                        @for (accordionItem of item.parsedResources2.items; track accordionItem.title; let i = $index) {
                            <h3 (click)="toggleAccordion2(i)">
                                <i class="icon-angle-right" [class.open]="openStates2[i]"></i>
                                {{ accordionItem.title }}
                            </h3>
                            @if (openStates2[i]) {
                                <div [innerHTML]="accordionItem.content"></div>
                            }
                        }
                    </div>
                }
            </div>
        }
    }        
</div>
